<template>
  <div class="comContent">
    <searchForm v-model="searchData" @getList="getList" :labelList="searchLabelList" :searchData="searchData"
      @reset="resetForm" :showExport="false" :isShowAddress="true"></searchForm>

    <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
      :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
      <template slot="operational" slot-scope="scope">
        {{ scope.row.operational == 0 ? '解冻' : scope.row.operational == 1 ? '冻结' : scope.row.operational == 2 ? '关店' :
          scope.row.operational == 3 ? '检查' : '' }}
      </template>
      <template slot="operation" slot-scope="scope">
        <div style="margin: 0 0px">
          <el-link type="primary" :underline="false" @click="checkShop(scope.row, 1)" style="margin-right: 10px" v-if=" scope.row.operational == 3">
            查看详情
          </el-link>
        </div>
      </template>

    </myTable>
    <el-dialog title="检查商户" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div>
        <div class="left_topic">
          检查项
        </div>
        <div class="to-page">
          <p @click="toPage('/productManage/goodsManage-baseDepot-index', '药品信息展示')">*药品信息展示</p>
          <p @click="toPage('/business/commodityOpsList-index')">*药品销售</p>
          <p @click="toPage('/business/businessManage-order-index')">*订单配送</p>
          <p @click="toPage('/audit/auditcenter-salesTreatment')">*售后处理</p>
          <p @click="toPage('/audit/auditcenter-auditcompany')">*资质</p>
        </div>
        <div class="left_topic">
          检查结果
        </div>
        <el-input v-model="textArea" disabled style="margin-top:10px;width: 100%;height: 120px; !important"
          placeholder="暂无检查结果" type="textarea"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <!-- <el-button type="primary"
                   @click="submit()"
                   size="small">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "../component/searchForm.vue";
import myTable from "@/components/myTable";
import { shopcheckrecordPage, shopcheckrecordInfo } from "@/api/businessManage";

export default {
  name: "monitoringRecord", 
  components: { searchForm, myTable },
  props: {},
  data() {
    return {
      dialogVisible: false,
      selectRow: {},
      textArea: '',

      loading: false,
      operation: false,
      selection: true,
      index: false,
      page: {
        total: 11,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "商户ID", prop: "shopCode", width: 160 },
        { label: "商户名称", prop: "shopName", width: 260 },
        { label: "商户类型", prop: "shopType", width: 200 },
        { label: "登录用户名", prop: "userName", width: 200 },
        { label: "操作内容", prop: "operational", slot: true },
        { label: "操作时间", prop: "createTime" },
        { label: "操作人", prop: "createBy" },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 120,
          // fixed: "right",
        },
      ],
      searchData: {
        shopName: "",
        shopCode: "",
      },
      searchLabelList: [
        {
          name: "商户ID",
          fieldName: "shopCode",
          type: "input",
          disabled: false,
        },
        {
          name: "商户名称",
          fieldName: "shopName",
          type: "input",
        },
        {
          name: "检查日期",
          fieldName: "date",
          type: "date",
        },
        {
          name: "资质检查结果",
          width: 150,
          fieldName: "certifyStatus",
          type: "select",
          disabled: false,
          select: [
           
            {
              name: "合格",
              id: 1,
            },
            {
              name: "不合格",
              id: 2,
            }
          ],
        },
        {
          name: "商品检查结果",
          width: 150,
          fieldName: "goodsStatus",
          type: "select",
          disabled: false,
          select: [
            
            {
              name: "合格",
              id: 1,
            },
            {
              name: "不合格",
              id: 2,
            }
          ],
        },
        {
          name: "订单检查结果",
          width: 150,
          fieldName: "orderStatus",
          type: "select",
          disabled: false,
          select: [
          
            {
              name: "合格",
              id: 1,
            },
            {
              name: "不合格",
              id: 2,
            }
          ],
        },
        {
          name: "售后检查结果",
          width: 150,
          fieldName: "afterSaleStatus",
          type: "select",
          disabled: false,
          select: [
            
            {
              name: "合格",
              id: 1,
            },
            {
              name: "不合格",
              id: 2,
            }
          ],
        },
        // {
        //   name: "登录用户名",
        //   fieldName: "userName",
        //   type: "input",
        // }, //后端和产品确认去掉
      ],
      shopName: null
    };
  },
  filters: {},
  created() { },
  mounted() {
    this.getList();
  },
  activated() {
    console.log("这是一个被缓存的组件");
    this.getList();
  },
  methods: {
    toPage(url, type) {
      this.$router.push(url + '?shopName=' + this.shopName)
    },
    // 检查
    checkShop(row) {
      this.selectRow = row
      this.textArea = row.checkResult
     
      this.shopName = row.shopName;
      console.log(row)

      // 检查详情记录
      console.log(row, '---row')
      if(row.operational == 3) {
        this.$router.push({
          path: "./businessManage-checkShop-record",
          query: {
            recordId: row.id
          },
        });
      }else{
       this.dialogVisible = true
      } 
     
    },
    handleClose() {
      this.dialogVisible = false
      this.textArea = ''
      this.shopId = null;
    },

    getList(current) {
      if (this.searchData.date) {
        this.searchData.startTime = this.searchData.date[0];
        this.searchData.endTime = this.searchData.date[1];
      }
      //console.log(this.searchData)
      let params = Object.assign({}, this.searchData);
      params.size = this.page.size;
      if(params.date) {
        delete params.date
      }
      //console.log(params)
      if (current) {
        params.current = 1;
      } else {
        params.current = this.page.current;
      }
      shopcheckrecordPage(params).then((res) => {
        console.log(res)
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    resetForm() {
      // this.searchData = {};
      this.page.current = 1;
      for (const key in this.searchData) {
        this.searchData[key] = ""
      }
      this.getList()
    },
    // // 查看详情
    // checkDetails (row) {
    //   shopcheckrecordInfo(row.id).then(res => {
    //     console.log(res)
    //   })
    // },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-textarea {
  .el-textarea__inner {
    height: 100%;
  }
}

::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.to-page p:hover {
  color: #f5222d;
  text-decoration: underline;
  cursor: pointer;
}

.to-page p {
  // text-decoration: underline;

}
</style>
